<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container modal-container-40" @mousedown="dontClose">
          <div class="modal-body m-0" style="overflow-y: auto;" :style="{maxHeight: getMaxHeightClient() + 'px'}">
            <div slot="formcontent" style="margin: 0px 20px 0px 20px;">
              <b-row class="panel-heading">
                <h4 class="content-block labelAccordionForm">
                  <i class="fa-light fa-save mr-2" style="font-size: 20px"></i>
                  {{ $t('common.routing.network.add_bic') }}
                </h4>
              </b-row>
              <b-row>
                <b-col>
                  <form-write-group-label-input
                    v-model="identifier"
                    isMandatory
                    :inputLabel="$t('common.global.bic')" />
                </b-col>
                <b-col>
                  <form-write-group-label-input
                    v-model="name"
                    isMandatory
                    :inputLabel="$t('common.global.provider_title')" />
                </b-col>
              </b-row>
            </div>
          </div>
          <div class="modal-footer">
              <b-button variant="primary" :disabled="!identifier || !name"
                @click="addNetworkBIC()">{{ $t('common.add_label') }}
              </b-button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>

import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'

export default {
  name: 'ChoiceBICCountry',
  components: {
    'form-write-group-label-input': formWriteGroupLabelInput
  },
  props: {
    data: {
      type: Object
    }
  },
  data () {
    return {
      mousedown: false,
      identifier: '',
      idNetwork: '',
      name: ''
    }
  },
  created () {
    this.idNetwork = this.data.idNetwork
    this.identifier = this.data.identifier
    this.name = this.data.name
    window.addEventListener('resize', this.changeMaxHeightClient)
    window.addEventListener('mousedown', this.handleMouseDown)
    window.addEventListener('mouseup', this.handleMouseUp)
  },
  destroyed () {
    window.removeEventListener('resize', this.changeMaxHeightClient)
  },
  methods: {
    addNetworkBIC () {
      this.$bus.emit('create-bic-network', {
        idNetwork: this.idNetwork,
        identifier: this.identifier,
        name: this.name
      })
    },
    changeMaxHeightClient () {
      let maxHeight = document.querySelector('body').clientHeight
      document.querySelector('.modal-container').setAttribute('style', 'overflow-y:auto;max-height: ' + maxHeight + 'px')
    },
    dontClose (e) {
      e.stopPropagation()
    },
    getMaxHeightClient () {
      return document.querySelector('body').clientHeight
    },
    handleMouseDown (e) {
      if (!this.mousedown) {
        if (e.target.closest('.modal-mask') || e.target.closest('.close-button')) {
          this.$emit('close')
        }
        this.mousedown = true
      }
    },
    handleMouseUp () {
      this.mousedown = false
    }
  }
}
</script>

<style scoped>
</style>
